import { render, staticRenderFns } from "./InstruksiKhususPimpinan.vue?vue&type=template&id=1a275063&scoped=true&lang=html&"
import script from "./InstruksiKhususPimpinan.vue?vue&type=script&lang=js&"
export * from "./InstruksiKhususPimpinan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a275063",
  null
  
)

export default component.exports